export default {
  discountTitle: {
    en: 'How about {discount} off next month?',
  },
  nextMonthTitle: {
    en: 'Stick around longer: next {monthsCount, plural, one {month} other {# months}} for {discountPrice}',
  },

  text: {
    en: `
    Before you go, we'd like to offer you this discount! 
    Once redeemed, you'll get your next {monthsCount, plural, one {monthly fragrance} other {# fragrances}} for 
    <span>just {discountPrice}</span> (normally {defaultPrice})
  `,
  },

  discountButtonLabel: {
    en: 'Stick around for <strong>{discount} off </strong>',
  },
  nextMonthButtonLabel: {
    en: 'Next {monthsCount, plural, one {month} other {# months}} <strong>for {discountPrice}</strong>',
  },

  cancelSubscription: {
    en: 'Cancel my subscription',
  },
}
